export default __webpack_public_path__ + "assets/img/brand-ex.png";